import * as yup from 'yup';
import { requiredMsg } from '../../utils/validationMessages';
import { transactionCurrencyIdField } from '../../../../../../../schemas/transactions/TransactionsCommon.schema';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import { pricePerShareField, usdField } from '../../../../../../../schemas/common-schema-defs';
import { isObject } from '../../../../../../../util/object-util';

export function miscInternalValuationFields() {
  return {
    transactionDate: transactionDateSchema(),
    currencyid: transactionCurrencyIdField(),
    valuationImpact: yup.boolean(),
    fundId: yup
      .number()
      .nullable()
      .when('valuationImpact', {
        is: false,
        then: (schema) => schema.required(requiredMsg('Fund')),
      }),
    pricePerShare: pricePerShareField()
      .nullable()
      .test((value, context) => {
        const valuationImpact = context?.parent?.valuationImpact;
        if (!valuationImpact || context?.parent?._viewModel?.showPpsShareClass) {
          return true;
        }
        if (value == null) {
          return context.createError({
            path: 'pricePerShare',
            message: requiredMsg('Price Per Share'),
          });
        }
        if (value < 0) {
          return context.createError({
            path: 'pricePerShare',
            message: 'Price Per Share must be at least 0',
          });
        }

        return true;
      }),
    _viewModel: yup.object({
      ppsShareClass: yup
        .object()
        .nullable()
        .test((value, context) => {
          if (!context?.parent?.showPpsShareClass) {
            return true;
          }
          if (isObject(value) && Object.entries(value as object).every(([_, v]) => v != null)) {
            return true;
          }
          return context.createError({
            path: '_viewModel.showPpsShareClass',
            message: 'These fields are required',
          });
        }),
    }),
    valuationAmount: usdField()
      .nullable()
      .when('valuationImpact', {
        is: false,
        then: (schema) => schema.required(requiredMsg('Change in Unrealized')),
      }),
    notes: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
  };
}

export function miscInternalValuationFormSchema() {
  return yup.object().shape(miscInternalValuationFields());
}

export function miscInternalValuationGridSchema() {
  return yup
    .object()
    .shape(miscInternalValuationFields())
    .omit(['valuationImpact', 'valuationAmount', '_viewModel']);
}
